import { render, staticRenderFns } from "./login_in_embed.vue?vue&type=template&id=a229ddd0&scoped=true&"
import script from "./login_in_embed.vue?vue&type=script&lang=js&"
export * from "./login_in_embed.vue?vue&type=script&lang=js&"
import style0 from "./login_in_embed.vue?vue&type=style&index=0&id=a229ddd0&lang=less&scoped=true&"
import style1 from "./login_in_embed.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a229ddd0",
  null
  
)

export default component.exports